export default "__VITE_ASSET__BLtBKJ8m__"